var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuyers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33366 18.6663C6.0409 18.6663 6.71918 18.3854 7.21928 17.8853C7.71937 17.3852 8.00033 16.7069 8.00033 15.9997C8.00033 15.2924 7.71937 14.6142 7.21928 14.1141C6.71918 13.614 6.0409 13.333 5.33366 13.333C4.62641 13.333 3.94814 13.614 3.44804 14.1141C2.94794 14.6142 2.66699 15.2924 2.66699 15.9997C2.66699 16.7069 2.94794 17.3852 3.44804 17.8853C3.94814 18.3854 4.62641 18.6663 5.33366 18.6663Z",
    fill: "#007696",
    stroke: "#007696",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0003 5.33317C28.3539 5.33317 28.6931 5.19269 28.9431 4.94265C29.1932 4.6926 29.3337 4.35346 29.3337 3.99984C29.3337 3.64622 29.1932 3.30708 28.9431 3.05703C28.6931 2.80698 28.3539 2.6665 28.0003 2.6665C27.6467 2.6665 27.3076 2.80698 27.0575 3.05703C26.8075 3.30708 26.667 3.64622 26.667 3.99984C26.667 4.35346 26.8075 4.6926 27.0575 4.94265C27.3076 5.19269 27.6467 5.33317 28.0003 5.33317ZM28.0003 17.3332C28.3539 17.3332 28.6931 17.1927 28.9431 16.9426C29.1932 16.6926 29.3337 16.3535 29.3337 15.9998C29.3337 15.6462 29.1932 15.3071 28.9431 15.057C28.6931 14.807 28.3539 14.6665 28.0003 14.6665C27.6467 14.6665 27.3076 14.807 27.0575 15.057C26.8075 15.3071 26.667 15.6462 26.667 15.9998C26.667 16.3535 26.8075 16.6926 27.0575 16.9426C27.3076 17.1927 27.6467 17.3332 28.0003 17.3332ZM28.0003 29.3332C28.3539 29.3332 28.6931 29.1927 28.9431 28.9426C29.1932 28.6926 29.3337 28.3535 29.3337 27.9998C29.3337 27.6462 29.1932 27.3071 28.9431 27.057C28.6931 26.807 28.3539 26.6665 28.0003 26.6665C27.6467 26.6665 27.3076 26.807 27.0575 27.057C26.8075 27.3071 26.667 27.6462 26.667 27.9998C26.667 28.3535 26.8075 28.6926 27.0575 28.9426C27.3076 29.1927 27.6467 29.3332 28.0003 29.3332Z",
    stroke: "#007696",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3333 4H13.3333V28H21.3333M8 16H21.3333",
    stroke: "#007696",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuyers);
export default __webpack_public_path__ + "static/media/buyers.2f6d6e1670e67988b6a7868a0b36e847.svg";
export { ForwardRef as ReactComponent };